// extracted by mini-css-extract-plugin
export default {"input":"U2Ll2","form":"UfysC"};